import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { ICustomNavigatorType } from '../../Coordinator/CustomNavigator/ICustomNavigator';
export const CustomScreenView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.customScreen,
    dependencies: {
        navigator: ICustomNavigatorType
    }
})(({ name, Component, navigator, props }) => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const sub = navigator === null || navigator === void 0 ? void 0 : navigator.getScreenParams(name).subscribe(({ visible }) => setVisible(visible));
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
    }, [name]);
    if (!visible) {
        return null;
    }
    return _jsx(Component, Object.assign({}, props));
});
